import React from 'react';

// Hand-drawn style decorative doodles (original line art).
// Use stroke="currentColor"; colour & opacity via Tailwind text-* classes on the wrapper.

export function SketchLineChart({ className = '' }) {
  return (
    <svg viewBox="0 0 200 150" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
        <path d="M22,18 C20,60 21,110 22,128" />
        <path d="M22,128 C70,129 140,127 182,128" />
        <polyline points="34,112 70,82 100,92 132,52 170,28" strokeWidth="2.6" />
        <path d="M170,28 L183,14" />
        <path d="M178,13 L184,13 L184,20" />
      </g>
      <g fill="currentColor">
        <circle cx="34" cy="112" r="3.2" />
        <circle cx="70" cy="82" r="3.2" />
        <circle cx="100" cy="92" r="3.2" />
        <circle cx="132" cy="52" r="3.2" />
        <circle cx="170" cy="28" r="3.6" />
      </g>
    </svg>
  );
}

export function SketchBars({ className = '' }) {
  return (
    <svg viewBox="0 0 180 150" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
        <path d="M20,16 C18,60 19,112 20,130" />
        <path d="M20,130 C64,131 134,129 170,130" />
        <rect x="36" y="58" width="22" height="72" />
        <rect x="72" y="40" width="22" height="90" />
        <rect x="108" y="74" width="22" height="56" />
        <rect x="144" y="92" width="22" height="38" />
      </g>
    </svg>
  );
}

export function SketchArrow({ className = '' }) {
  return (
    <svg viewBox="0 0 160 90" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8,70 C40,66 70,40 150,14" />
        <path d="M128,10 L151,13 L142,33" />
      </g>
    </svg>
  );
}

export function SketchSquiggle({ className = '' }) {
  return (
    <svg viewBox="0 0 200 40" fill="none" className={className} aria-hidden="true">
      <path
        d="M4,22 C30,6 46,34 72,20 C98,6 114,34 140,20 C166,6 182,30 196,18"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SketchPie({ className = '' }) {
  return (
    <svg viewBox="0 0 120 120" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="60" cy="60" r="46" />
        <path d="M60,60 L60,14" />
        <path d="M60,60 L101,78" />
      </g>
    </svg>
  );
}

export function SketchScatter({ className = '' }) {
  return (
    <svg viewBox="0 0 160 120" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
        <path d="M22,12 C20,50 21,90 22,104" />
        <path d="M22,104 C60,105 120,103 150,104" />
        <path d="M30,96 C70,84 108,40 146,22" strokeDasharray="3 7" />
      </g>
      <g fill="currentColor">
        <circle cx="42" cy="86" r="3" />
        <circle cx="60" cy="74" r="3" />
        <circle cx="78" cy="66" r="3" />
        <circle cx="96" cy="52" r="3" />
        <circle cx="116" cy="40" r="3" />
        <circle cx="134" cy="30" r="3" />
      </g>
    </svg>
  );
}
